package com.mxpainting.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import com.mxpainting.Strings
import com.mxpainting.Language
import com.mxpainting.rememberLanguage
import com.mxpainting.components.layouts.PageLayout
import com.mxpainting.components.sections.Carousel
import com.mxpainting.components.sections.WhatWeOffer
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.B
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.H5
import org.jetbrains.compose.web.dom.I
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Section
import org.jetbrains.compose.web.dom.Text

@Page
@Composable
fun HomePage() {
    val language by rememberLanguage()

    PageLayout {
        Column(Modifier.fillMaxSize()) {
            Carousel()

            // Intro
            Intro(language)

            // What We Offer
            WhatWeOffer(language)

            // Trusted by the Community
            TrustedByTheCommunity(language)
        }
    }
}

@Composable
fun Intro(language: Language) {
    Div(Modifier.classNames("container").toAttrs {
                style { property("padding", "2rem") }
            }) {
                H1 { Text(Strings.homeHeroHeader[language]!!) }
                P {
                    Text(Strings.homeIntroP1Part1[language]!!)
                    B { Text(Strings.homeIntroP1Bold[language]!!) }
                    Text(Strings.homeIntroP1Part2[language]!!)
                }
                P { Text(Strings.homeIntroP2[language]!!) }
                P {
                    Text(Strings.homeIntroP3Part1[language]!!)
                    A(href = "/contact") { B { Text(Strings.homeIntroP3Bold[language]!!) } }
                    Text(Strings.homeIntroP3Part2[language]!!)
                }
            }
}


@Composable
private fun CommunityItem(href: String, label: String, description: String, iconContent: @Composable () -> Unit) {
    A(href = href, attrs = { classes("community-item") }) {
        iconContent()
        Div(attrs = { classes("ci-text") }) {
            H5 { Text(label) }
            P { Text(description) }
        }
    }
}

@Composable
private fun TrustedByTheCommunity(language: com.mxpainting.Language) {
    Section(Modifier.classNames("community-strip").toAttrs()) {
        Div(Modifier.classNames("container").toAttrs()) {
            H2(Modifier.classNames("text-center", "mb-5").toAttrs()) { Text(Strings.homeCommunityHeader[language]!!) }
            Div(
                Modifier.classNames("d-flex", "justify-content-center", "align-items-center", "flex-wrap", "gap-3")
                    .toAttrs()
            ) {
                CommunityItem(
                    "https://trustedpros.ca/company/mx-painting", "TrustedPros", Strings.homeCommunityVerified[language]!!,
                    iconContent = {
                        Img(
                            src = "/img/trusted-pros-logo.webp",
                            alt = "TrustedPros",
                            attrs = { classes("ci-icon") })
                    })
                Div(Modifier.classNames("community-divider").toAttrs()) {}
                CommunityItem(
                    "https://www.facebook.com/MX-Painting-931817703684196/", "Facebook", Strings.homeCommunityFollow[language]!!,
                    iconContent = {
                        Div(attrs = { classes("ci-icon") }) {
                            I(attrs = {
                                classes(
                                    "fab",
                                    "fa-facebook-f"
                                )
                            }) {}
                        }
                    })
                Div(Modifier.classNames("community-divider").toAttrs()) {}
                CommunityItem(
                    "https://www.instagram.com/mxpainting/", "Instagram", Strings.homeCommunityGallery[language]!!,
                    iconContent = {
                        Div(attrs = { classes("ci-icon") }) {
                            I(attrs = {
                                classes(
                                    "fab",
                                    "fa-instagram"
                                )
                            }) {}
                        }
                    })
                Div(Modifier.classNames("community-divider").toAttrs()) {}
                CommunityItem(
                    "https://www.google.com/search?q=mx+painting+reviews", "Google Reviews", Strings.homeCommunityReviews[language]!!,
                    iconContent = {
                        Div(attrs = { classes("ci-icon") }) {
                            I(attrs = {
                                classes(
                                    "fab",
                                    "fa-google"
                                )
                            }) {}
                        }
                    })
            }
        }
    }
}
